import React, { useState, useEffect, useContext, useRef } from "react";

import { DataGrid } from "@material-ui/data-grid";
import { Container, Grid, IconButton, Tooltip } from "@material-ui/core";
import { EditOutlined, AddOutlined } from "@material-ui/icons";

import { GridStyled, IconButtonStyled } from "../../styles/GlobalStyle";
import { TitleTable } from "../../components/basic/TitleTable";
import filterTable from "../../utils/filterTable";
import { UpdateCreateCancellation } from "./UpdateCreateCancellation";
import { UserContext } from "../../context/UserContext";
import { getCancellations } from "../../repositories/cancellationRepository";

function PreviewCancellation() {
  const { user } = useContext(UserContext);
  const [page, setPage] = useState(0);
  const [allRows, setAllRows] = useState([]);
  const [rowsFilter, setRowsFilter] = useState([]);
  const [loading, setLoading] = useState(false);
  const [rowEdit, setRowEdit] = useState({});
  const [openModal, setOpenModal] = useState(false);
  const searchRef = useRef(null);

  const columns = [
    {
      field: "Id",
      headerName: "Id",
      width: 100,
    },
    {
      field: "Descricao",
      headerName: "Descrição",
      minWidth: 200,
      flex: 1,
    },
    {
      field: "TipoContato",
      headerName: "Tipo de Contato",
      minWidth: 100,
      flex: 0.2,
    },
    {
      field: "TipoStatus",
      headerName: "Tipo de Status",
      minWidth: 80,
      flex: 0.2,
      align: "center",
    },
  ];

  if (user.accessRoutes.includes("/updateCancellation")) {
    columns.unshift({
      field: "Acoes",
      headerName: "Acões",
      width: 80,
      renderCell: ({ row }) => (
        <Tooltip title="Editar Motivo">
          <IconButton
            onClick={() => {
              setRowEdit(row);
              setOpenModal(true);
            }}
          >
            <EditOutlined />
          </IconButton>
        </Tooltip>
      ),
      align: "center",
    });
  }

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);

        const { data: response } = await getCancellations();

        setAllRows(response.data);
        setRowsFilter(response.data);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const handleChangeFilter = (e) => {
    e.preventDefault();

    if (!searchRef?.current?.value) return setRowsFilter(allRows);

    const newArr = filterTable({
      data: allRows,
      text: searchRef?.current?.value,
      columns: ["Id", "Descricao", "TipoContato", "TipoStatus"],
    });

    setRowsFilter(newArr);
    setPage(0);
  };

  const handleSave = (body) => {
    const copyAllRows = [...allRows];
    const copyRowsFilter = [...rowsFilter];

    if (rowEdit.Id) {
      const indexAllRows = copyAllRows.findIndex((i) => i.Id === rowEdit.Id);
      copyAllRows[indexAllRows] = body;

      const indexRowsFilter = copyRowsFilter.findIndex(
        (i) => i.Id === rowEdit.Id
      );
      copyRowsFilter[indexRowsFilter] = body;

      setAllRows(copyAllRows);
      setRowsFilter(copyRowsFilter);
      return;
    }

    setAllRows([...copyAllRows, body]);
    setRowsFilter([...copyRowsFilter, body]);
  };

  const handleClose = () => {
    setOpenModal(false);
    setRowEdit({});
  };

  return (
    <Container maxWidth="lg">
      {openModal && (
        <UpdateCreateCancellation
          row={rowEdit}
          handleClose={handleClose}
          handleSave={handleSave}
        />
      )}
      <GridStyled
        container
        padding="20px 0 20px 0"
        justify="space-between"
        spacing={3}
      >
        <Grid item xs={12}>
          <TitleTable
            inputRef={searchRef}
            labelFilter="Filtro (Id, Descrição, Tipo de Contato)"
            title="Motivos de Cancelamento"
            handleFilter={handleChangeFilter}
            loading={loading}
            children={
              user.accessRoutes.includes("/createCancellation") ? (
                <Grid item flex={1}>
                  <Tooltip title="Adicionar Motivo">
                    <IconButtonStyled
                      onClick={() => {
                        setOpenModal(true);
                        setRowEdit({});
                      }}
                    >
                      <AddOutlined />
                    </IconButtonStyled>
                  </Tooltip>
                </Grid>
              ) : null
            }
          />
        </Grid>

        <Grid item xs={12}>
          <DataGrid
            autoHeight
            disableColumnMenu
            loading={loading}
            rows={rowsFilter}
            columns={columns}
            pageSize={10}
            getRowId={(row) => row.Id}
            page={page}
            onPageChange={(e) => setPage(e?.page || 0)}
          />
        </Grid>
      </GridStyled>
    </Container>
  );
}

export { PreviewCancellation };
